import PropTypes from "prop-types";
import React from "react";
import {getButtonClasses} from "../Inputs/inputUtility";

export const ExternalLink = (props) => {
    const {className, hasNoIcon} = props;
    let classes = className ? className
        : hasNoIcon ? "noIcon"
            : undefined;

    return <ExternalLinkAdapter {...props} className={classes}/>;
};

export const ExternalLinkButton = (props) => {
    let classes = getButtonClasses(props);

    return <ExternalLinkAdapter {...props} className={classes} />;
};
export const ExternalTertiaryLinkButton = (props) => {
    let classes = getButtonClasses({...props, isTertiary:true});

    return <ExternalLinkAdapter {...props} className={classes} />;
};

export const ExternalLinkTitle = ({className, title, url}) =>
    <ExternalLinkAdapter label={``} title={title} url={url} className={`noIcon ${className}`}/>;

const ExternalLinkAdapter = ({className, label, url, opensInNewTab = true, title, handleClick = () => {}}) => {
    if (!label && !title) return <> </>;

    const newTabTarget = opensInNewTab ? "_blank" : null;
    const newTabRel = opensInNewTab ? "noopener noreferrer" : null;

    return (
        <a href={url} className={className} target={newTabTarget} rel={newTabRel} title={title} onClick={handleClick}>
            {label}
        </a>
    );
};

const sharedProps = {
    className: PropTypes.string,
    label: PropTypes.any,
    opensInNewTab: PropTypes.bool,
    title: PropTypes.string,
    url: PropTypes.string,
    handleClick: PropTypes.func,
};

const buttonProps = {
    isExpanded: PropTypes.bool,
    isPrimary: PropTypes.bool,
};

ExternalLink.propTypes = {
    hasNoIcon: PropTypes.bool,
    ...sharedProps,
};
ExternalLinkButton.propTypes = {
    ...buttonProps,
    ...sharedProps,
};

ExternalTertiaryLinkButton.propTypes = {
    isExpanded: PropTypes.bool,
    ...sharedProps,
};

ExternalLinkTitle.propTypes = {
    ...sharedProps,
};

ExternalLinkAdapter.propTypes = {
    ...sharedProps,
};